import { Injectable } from '@angular/core';
import { Observable, config } from 'rxjs';
import { Papa } from 'ngx-papaparse';

export class ExportFieldConfig {
  label: string;
  field: string;
}

@Injectable({
  providedIn: 'root'
})
export class ExportService {
  
  constructor(private papa: Papa) { }

  importCSV(csv: string): Observable<[string[]]> {
    return new Observable<[string[]]>((observer) => {
      const { data, errors } = this.papa.parse(csv);

      if (errors.length) {
        observer.error(errors);
        observer.complete();
      } else {
        observer.next(data);
        observer.complete();
      }
    });
  }

  exportCSV(rows: any[], columns: ExportFieldConfig[], includeHeader: boolean = true): Observable<string> {
    const exportRows: any[] = [];

    // #TODO: [AC] - ngx-papaparse wrapper doesn't support explicit header columns, manually build rows[]
    // add header
    if (includeHeader) {
      exportRows.push(columns.map(c => c.label));
    }

    // add data rows
    rows.forEach((row) => {
      const dataRow = columns.map((col) => row[col.field]);
      exportRows.push(dataRow);
    });

    return new Observable<string>((observer) => {
      const csv = this.papa.unparse(exportRows, { quotes: true, header: false });
      observer.next(csv);
      observer.complete();
    });
  }
}
